/**
 * Egypt's tag. `Intl` resolves a BARE `ar` to the `latn` numbering system, so
 * `(5).toLocaleString("ar")` returns "5", not "٥". `ar-EG` resolves to `arab`.
 */
const ARABIC_LOCALE = "ar-EG";
const ENGLISH_LOCALE = "en-US";

/**
 * Turn a portal locale ("ar" | "en") into the tag `Intl` should actually be
 * given. Several call sites write `locale === "ar" ? "ar-EG" : "en-US"` inline;
 * that is this function, copied — prefer this so there is one place to be right.
 */
export function intlLocale(locale: string): string {
  return locale === "ar" ? ARABIC_LOCALE : ENGLISH_LOCALE;
}
